<template>
  <router-view />
</template>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  position: absolute;
}

::-webkit-scrollbar-thumb {
  background-color: #0003;
  border-radius: 10px;
  transition: all .2s ease-in-out;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #0000004d
}


::-webkit-scrollbar-track {
  border-radius: 10px;
  background: #ddd;
}

.el-loading-mask.is-fullscreen {
  z-index: 20004 !important;
}
</style>
